/**
 * Shared hash-based navigation utilities.
 * Used by sidebar pages that deep-link via URL hash fragments.
 */

/** Read the current hash (without the leading #), URL-decoded. */
export function readHash(): string {
  const raw = window.location.hash.replace(/^#/, "");
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

/** Set the hash (triggers hashchange for other listeners). */
export function setHash(hash: string): void {
  window.location.hash = encodeURIComponent(hash);
}

/** Replace the current URL hash without pushing a history entry. */
export function syncHash(hash: string): void {
  window.history.replaceState(null, "", `#${encodeURIComponent(hash)}`);
}

/**
 * Register a hashchange listener. Returns a cleanup function
 * to call in componentWillUnmount.
 */
export function initHashNav(onHashChange: (hash: string) => void): () => void {
  const listener = () => onHashChange(readHash());
  window.addEventListener("hashchange", listener);
  return () => window.removeEventListener("hashchange", listener);
}
